import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import { flexCenter } from '../../styles/mixins';

const std = {
  fontFamily: ThemeFont.FONT_CONDENSED,
  fontWeight: 'bold',
  color: ThemeColors.COLOR_GREY3,
};

const active = {
  fontFamily: ThemeFont.FONT_CONDENSED,
  fontWeight: 'bold',
  color: ThemeColors.COLOR_WHITE,
};

const segment = token => ({
  flex: 1,
  ...flexCenter(),
  cursor: 'pointer',
  borderRadius: token.borderRadius,
  transitionProperty: 'left, right',
  transitionDuration: '300ms',

  '&.disabled': {
    cursor: 'not-allowed',
  },
});

const indicatorPositions = (number, suffix) => {
  const rules = {};
  for (let i = 1; i <= number; i += 1) {
    const selector = `.SegmentedControl-Segment${suffix}:nth-child(${i}) ~ .SegmentedControl-ActiveIndicator`;
    rules[selector] = {
      left: `${((i - 1) * 100) / number}%`,
      right: `${(i * 100) / number}%`,
    };
  }
  return rules;
};

const numberSpecific = number => ({
  [`&.num-items-${number}`]: {
    '.SegmentedControl-Segment, .SegmentedControl-ActiveIndicator': {
      width: `${100 / number}%`,
    },
    // Hover has higher priority, so it must be later
    ...indicatorPositions(number, '.active'),
    ...indicatorPositions(number, ':hover'),
  },
});

export const useSegmentedControlStyles = createStyles(({ token }) => ({
  segmentedControl: {
    width: '100%',
    height: 32,
    backgroundColor: ThemeColors.COLOR_GREY8_9,
    borderRadius: token.borderRadius,
    padding: ThemeSpaces.SPACE_NORM0_5,

    '.StepsWithContent > &': {
      width: 'initial',
    },

    '.SegmentedControl-Inner': {
      width: '100%',
      height: '100%',
      position: 'relative',
      display: 'flex',

      '&:hover .SegmentedControl-Segment.active': {
        ...std,
        '&:hover': {
          ...active,
        },
      },
    },

    '.SegmentedControl-Segment': {
      ...segment(token),
      ...std,
      zIndex: 2,

      '&.active, &:hover': {
        ...active,
      },
    },

    '.SegmentedControl-ActiveIndicator': {
      ...segment(token),
      position: 'absolute',
      top: 0,
      bottom: 0,
      zIndex: 1,
      backgroundColor: ThemeColors.COLOR_RED,
      boxShadow:
        '4px 4px 5px rgba(0, 0, 0, 0.14), 1px 1px 10px rgba(0, 0, 0, 0.14)',
    },

    ...numberSpecific(2),
    ...numberSpecific(3),
    ...numberSpecific(4),
    ...numberSpecific(5),
  },
}));
